module.exports = __webpack_public_path__ + "img/fawry.62dec562.svg";